import { BOMFormat } from "./base";
/**
 * AllPCB BOM format
 * https://www.allpcb.com/components/bill-of-materials.html
 */
export class AllPCBFormat extends BOMFormat {
    static manufacturer = "AllPCB";
    static columns = {
        "Item #": (_item, rowNumber) => `${rowNumber}`, // not sure if this should be sequential number or a unique ID
        "Ref Des": (item) => item.designators.join(","),
        Qty: "quantity",
        Manufacturer: "manufacturer",
        "Mfg Part #": "mpn",
        "Description / Value": (item) => item.specification.join(", "),
        Package: "package",
        Type: "mountType",
        "Your Instructions / Notes": "notes",
    };
}
//# sourceMappingURL=AllPCB.js.map